import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    flexGrow: 1,
    overflow: 'hidden'
  },
  scrollableContent: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: ['20px', '20px', '28px'],
    paddingLeft: ['4px', '4px', '4px'],
    paddingBottom: ['24px', '24px', '32px'],
    width: '100%',
    ...reusables.scrollbar()
  },
  infoContainer: {
    padding: '16px',
    background: theme.rawColors.lightGreyBgProduct,
    marginTop: '24px',
    marginBottom: '24px'
  },
  infoText: {
    fontSize: theme.fontSizes.caption,
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    lineHeight: '140%',
    margin: 0
  },
  sectionTitle: {
    marginTop: '24px',
    marginBottom: '24px'
  },
  filler: {
    height: '48px'
  },
  reasonSelectWrapper: {
    position: 'relative',
    padding: '4px',
    margin: '-4px',
    marginBottom: '60px',
    overflow: 'visible'
  },
  reasonSelect: {
    '& [role="button"]:focus-visible': {
      outlineOffset: '-2px'
    }
  },
  commentContainer: {
    width: '100%',
    marginBottom: '16px'
  },
  selectionError: {
    fontSize: theme.fontSizes.smallText,
    color: theme.rawColors.accent700,
    marginTop: '8px'
  },
  submitButtonContainer: {
    marginTop: ['32px', '42px', '42px'],
    width: '100%'
  },
  submitButton: {
    width: '100%',
    minHeight: '60px',
    span: {
      fontFamily: theme.fonts.uniform,
      fontSize: theme.fontSizes.text,
      fontWeight: theme.fontWeights.medium,
      lineHeight: '140%',
      letterSpacing: '1.6px'
    }
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: ['40px 16px', '40px 16px', '64px 40px'],
    flex: 1,
    width: '100%'
  },
  successIconContainer: {
    padding: '32px',
    marginBottom: '24px'
  },
  successIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: `2px solid ${theme.rawColors.darkGrey700}`,
    width: '96px',
    height: '96px'
  },
  successTitle: {
    marginBottom: '16px'
  },
  successMessage: {
    fontFamily: theme.fonts.uniform,
    fontSize: theme.fontSizes.caption,
    color: theme.rawColors.darkGrey700,
    lineHeight: '140%',
    maxWidth: '520px',
    margin: 0
  },
  successFooter: {
    borderTop: `1px solid ${theme.rawColors.lightGrey300}`,
    padding: ['16px', '16px', '24px 24px 0 0'],
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexShrink: 0
  }
};